import { Avatar } from "@react-spectrum/s2";
import { useAvatarUrl } from "@app/hooks/useAvatarUrl";
import PropTypes from "prop-types";

/**
 * PersonaAvatar - Avatar component with built-in async URL loading
 *
 * @param {Object} props
 * @param {Object} props.persona - Persona object containing avatar information
 * @param {string} props.alt - Alt text for the avatar
 * @param {number} props.size - Size of the avatar
 * @param {boolean} props.isOverBackground - Whether avatar is over a background
 * @param {Object} props...rest - Any other Avatar props
 */
export const PersonaAvatar = ({ persona, alt, ...rest }) => {
  const avatarUrl = useAvatarUrl(persona);

  return <Avatar src={avatarUrl} alt={alt || persona?.name} {...rest} />;
};

PersonaAvatar.propTypes = {
  persona: PropTypes.object,
  alt: PropTypes.string,
};
